// Initialize animations when DOM is ready
document.addEventListener("DOMContentLoaded", function () {
    initSectionAnimations();
});

function initSectionAnimations() {
    // Define animation configs for each section type
    const animationConfigs = {
        "fade-up": {
            duration: 0.9,
            delay: 0.1,
            easing: [0.25, 0.46, 0.45, 0.94],
        },
        "fade-in": {
            duration: 0.8,
            delay: 0.2,
            easing: [0.25, 0.46, 0.45, 0.94],
        },
        "slide-left": {
            duration: 0.7,
            delay: 0.15,
            easing: [0.25, 0.46, 0.45, 0.94],
        },
        "slide-right": {
            duration: 0.7,
            delay: 0.15,
            easing: [0.25, 0.46, 0.45, 0.94],
        },
    };

    // Get all sections with data-animate attribute
    const sections = document.querySelectorAll("[data-animate]");

    // Use Intersection Observer for scroll-triggered animations
    const observerOptions = {
        threshold: 0.1,
        rootMargin: "0px 0px -50px 0px",
    };

    const observer = new IntersectionObserver(function (entries) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const animationType = entry.target.getAttribute("data-animate");
                const config = animationConfigs[animationType];

                if (config) {
                    animateElement(entry.target, animationType, config);
                }

                // Stop observing after animation triggers
                observer.unobserve(entry.target);
            }
        });
    }, observerOptions);

    // Observe all sections
    sections.forEach((section) => observer.observe(section));
}

function animateElement(element, type, config) {
    // Using Motion.dev (formerly Framer Motion) for animations
    // Note: Motion.dev is primarily for React, so we'll use Web Animations API
    // which is better for vanilla JS with Shopify themes

    const keyframes = getKeyframes(type);

    const customDelay = element.getAttribute("data-delay");
    const delayToUse = customDelay !== null ? parseFloat(customDelay) : config.delay;

    const options = {
        duration: config.duration * 1000, // Convert to ms
        delay: delayToUse * 700,
        easing: getCubicBezier(config.easing),
        fill: "forwards",
    };

    element.animate(keyframes, options);
}

function getKeyframes(type) {
    const keyframesMap = {
        "fade-up": [
            { opacity: 0, transform: "translateY(30px)" },
            { opacity: 1, transform: "translateY(0)" },
        ],
        "fade-in": [{ opacity: 0 }, { opacity: 1 }],
        "slide-left": [
            { opacity: 0, transform: "translateX(40px)" },
            { opacity: 1, transform: "translateX(0)" },
        ],
        "slide-right": [
            { opacity: 0, transform: "translateX(-40px)" },
            { opacity: 1, transform: "translateX(0)" },
        ],
    };

    return keyframesMap[type] || keyframesMap["fade-in"];
}

function getCubicBezier(bezier) {
    return `cubic-bezier(${bezier.join(",")})`;
}